import React, {useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';

import './styles.scss';
import * as fonts from '../../../util/fonts';
import {FormControlProps} from 'react-bootstrap';
import Icon from '../../icon';
import {Icons} from '../../../util/icons';
import {Row} from '../../layout';
import colors from '../../../util/colors';
import {createClassName, createGUID} from '../../../util/utility';
import {strings} from '../../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import DropdownInsuranceIcon from '../../../containers/appointments/components/schedule-appointments/icons/DropdownInsuranceIcon';

export interface Option {
  value: string | any;
  label: string;
}

interface AppSelectInputProps extends FormControlProps {
  onChange(value: any): any;
  placeholder?: any;
  onBlur?(): void;
  value?: any;
  options: Option[];
  className?: string;
  error?: string;
  buStyles: any;
  inputStyle?: any;
  labels?: typeof strings.pt.messages;
  defaultValue?: any;
  customIcon?: any;
}

function AppSelectInput({
  value,
  onChange,
  placeholder,
  onBlur,
  options,
  className,
  error,
  buStyles,
  inputStyle,
  labels,
  defaultValue,
  customIcon,
  ...rest
}: AppSelectInputProps) {
  const classes = createClassName(
    'app-text-input-row app-select-input-container',
    className
  );
  const [customIconState, setCustomIconState] = useState(customIcon);

  useEffect(() => {
    setCustomIconState(customIcon);
  }, [customIcon]);

  const renderIcon = () => {
    return customIconState ? (
      customIconState == 'DropdownInsuranceIcon' && (
        <Icon
          className="app-select-input-custom-icon"
          color={buStyles?.primaryColor || colors.blue}
          name={Icons.ROUND_CHEVRON_DOWN}
          width={'29'}
          height={'29'}
          strokeWidth={'0.1'}
        />
      )
    ) : customIconState == 'none' ? 
        <></>
      : (
      <Icon
        className="app-select-input-icon"
        color={buStyles?.primaryColor || colors.blue}
        name={Icons.CHEVRON_DOWN}
        width={'19'}
        height={'19'}
        strokeWidth={'1'}
      />
    );
  };

  return (
    <>
      <Row className={classes}>
        <Form.Control
          onBlur={onBlur}
          style={{
            ...fonts.M,
            color: value === '' && !!!placeholder ? '#7D7D7D' : colors.black,
            ...inputStyle,
            cursor: customIconState == 'none' && 'default'
          }}
          className="app-text-input app-select-input"
          as={'select'}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          onChange={(event) => onChange(event.target.value)}
          {...rest}>
          {[
            <option
              disabled={!!!placeholder}
              value={''}
              key={-1}
              style={{color: placeholder ? colors.black : colors.lightGrey}}>
              {placeholder || labels?.selectOption}
            </option>,
            ...options.map((option) => (
              <option
                key={`select-${option.value}-${createGUID()}`}
                value={option.value}>
                {option.label}
              </option>
            )),
          ]}
        </Form.Control>
        {error ? (
          <Icon
            width="24"
            height="24"
            className="app-form-field-error"
            name={Icons.ALERT_PROBLEM}
            color={colors.alertRed}
          />
        ) : (
          renderIcon()
        )}
      </Row>
    </>
  );
}

const mapStateToProps = ({globalStyles, strings}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.messages,
});

export default compose(connect(mapStateToProps)(AppSelectInput));
